<template>
  <div id="app" class="h-full w-full bg-white flex flex-col overflow-hidden">
    <div class="shadow">
      <!--<Header class="flex-shrink-0" :title="title" />-->
      <FilterMessage />
    </div>
    <div class="flex-grow overflow-y-auto">
      <HistamineList />
    </div>
    <SearchFilter class="flex-shrink-0" />
    <FilterSelect />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import HistamineList from '@/components/HistamineList.vue'
import SearchFilter from '@/components/SearchFilter.vue'
import FilterMessage from '@/components/FilterMessage.vue'
import FilterSelect from '@/components/FilterSelect.vue'

export default {
  name: 'app',
  data() {
    return {
      title: 'Histamine List'
    }
  },
  components: {
    Header, HistamineList, SearchFilter, FilterMessage, FilterSelect
  }
}
</script>

<style lang="scss">
@import './fonts.css';
/* purgecss start ignore */
@tailwind  base;
@tailwind  components;
/* purgecss end ignore */
@tailwind  utilities;

html, body{
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: 'HistInter', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
